/* question model styles that could be changed in global styling @sinslav */
export const BLOCK_MODEL_STYLING_KEYS = [
  'color',
  'textColor',
  'backgroundColor',
  'backButton.textColor',
  'backButton.backgroundColor',
];
